import React, { Component } from 'react';
import Page from '../components/Page';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Segment, Button, Placeholder } from 'semantic-ui-react';
import ChatIcon from '@mui/icons-material/Chat';
// eslint-disable-next-line
import styled, { StyleSheetManager, createGlobalStyle } from 'styled-components/macro';

class Chat extends Component {
	state = {
		loading: true,
	};
	chat = React.createRef();

	render() {
		const { product = {} } = this.props;
		let trial = this.props.product.trial;
		const pack = product.settings.subscription_package;
		const agent_limit = product.settings.agent_limit;
		if (pack === 'live' || pack === 'liveapi' || (pack === 'maytapi-custom-api' && agent_limit) || pack === 'maytapi-trial-live') {
			return (
				<Page disabled={window.innerWidth >= 1200 ? true : false} icon={<ChatIcon />} title="Live Chat" flex>
					<style
						dangerouslySetInnerHTML={{
							__html: `
						.css-s96ajf{
							padding:0 0 0 280px;
						}
						@media (max-width: 1200px) {
							.css-s96ajf {
								padding:0;
							}
						}`,
						}}
					/>
					<iframe
						title="chat"
						css={`
							flex: 1;
							border: none !important;
							width: 100%;
							height: 100%;
							//box-shadow: 0 1px 2px 0 rgba(34, 36, 38, 0.15), 0 0 0 1px rgba(34, 36, 38, 0.15);
							//border-radius: 5px;
							overflow: hidden;
						`}
						src={`/chat.html`}
						//initialContent={runCode(uid, isAdmin, wapi, wapi_token)}
					></iframe>
				</Page>
			);
		}
		return (
			<Page disabled={true}>
				<div
					css={`
						display: flex;
						width: 100%;
						height: 100%;
						flex-direction: column;
						position: relative;
					`}
				>
					<div
						css={`
							background: #eee;
							border-bottom: 1px solid rgba(0, 0, 0, 0.08);
							height: 44px;
						`}
					></div>
					<div
						css={`
							flex: 1;
							display: flex;
						`}
					>
						<div
							css={`
								width: 252px;
								background: #fff;
								box-shadow: 0 4px 13px 0 rgba(0, 18, 46, 0.16);
								height: 100%;
								padding: 16px;
							`}
						>
							<Placeholder>
								<Placeholder.Header image>
									<Placeholder.Line />
									<Placeholder.Line />
								</Placeholder.Header>
							</Placeholder>
							<Placeholder>
								<Placeholder.Header image>
									<Placeholder.Line />
									<Placeholder.Line />
								</Placeholder.Header>
							</Placeholder>
							<Placeholder>
								<Placeholder.Header image>
									<Placeholder.Line />
									<Placeholder.Line />
								</Placeholder.Header>
							</Placeholder>
						</div>
						<div
							css={`
								display: flex;
								flex: 1;
							`}
						></div>
					</div>
					<div
						css={`
							position: absolute;
							background: rgba(0, 0, 0, 0.2);
							display: flex;
							top: 0;
							left: 0;
							bottom: 0;
							right: 0;
							align-items: center;
							justify-content: center;
						`}
					>
						<Segment
							css={`
								text-align: center;
								max-width: 100%;
								width: 400px;
							`}
						>
							<h2>You dont have any LiveChat subscription.</h2>
							<p>
								{pack === 'maytapi-trial-api'
									? 'You have trial API subscription. If you want to use live chat, you must change trial subscription type.'
									: 'Please buy a LiveChat subscription first.'}
							</p>
							<Button as={Link} to="/subscription" primary>
								{trial === null ? 'Start Free Trial' : 'Go to Subscription'}
							</Button>
						</Segment>
					</div>
				</div>
			</Page>
		);
	}
}

const stateToProps = (state) => ({ product: state.product.maytapi });
export default connect(stateToProps)(Chat);
